
export const Locale = {
    "en_us": "English (US)",
    "en_gb": "English (UK)",  
    "it_it": "Italian (IT)",
    "pt_pt": "Portuguese (PT)",
    "es_es": "Spanish (ES)",
    "fr_fr": "French (FR)",
    "de_de": "German (DE)",
    "zh_cn": "Chinese (Simplified, CN)",
    "ja_jp": "Japanese (JP)"
  };
  